import React from 'react';

interface FacilityPageProps {
  title: string;
  backgroundImage?: string;
  description: string;
  features?: string[];
  images?: string[];
}

const FacilityPage: React.FC<FacilityPageProps> = ({ 
  title, 
  backgroundImage = '/images/bg-img/bdrc-bg.jpg',
  description,
  features = [],
  images = []
}) => {
  return (
    <main>
      <section className="breadcrumb-area d-flex align-items-center" style={{backgroundImage: `url(${backgroundImage})`}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>{title}</h2>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">{title}</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-area about-p pt-120 pb-120 p-relative fix">
        <div className="animations-02"><img src="/img/bg/an-img-02.png" alt="contact-bg-an-02" /></div>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            {images.length > 0 && (
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="s-about-img p-relative wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s">
                  <img src={images[0]} alt={title} />
                  {images[1] && (
                    <div className="about-icon">
                      <img src={images[1]} alt={title} />
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className={`col-lg-${images.length > 0 ? '6' : '12'} col-md-12 col-sm-12`}>
              <div className="about-content s-about-content wow fadeInRight animated pl-30" data-animation="fadeInRight" data-delay=".4s">
                <div className="about-title second-title pb-25">
                  <h2>{title}</h2>
                </div>
                <p style={{textAlign: 'justify'}}>{description}</p>
                
                {features.length > 0 && (
                  <div className="mt-4">
                    <h5 style={{color: '#c07e40'}}>Features & Highlights</h5>
                    <ul className="text-white">
                      {features.map((feature, index) => (
                        <li key={index} style={{marginBottom: '10px'}}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="about-content3 mt-30">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-md-12">
                      <div className="slider-btn">
                        <a href="/enquiry" className="btn ss-btn smoth-scroll">Book Now</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default FacilityPage;